import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const messages = {  
                    'en': 
                    {
                        sessionEmail: 'Email address',
                        sessionEmailPlaceholder:'Enter email',
                        sessionPassword:'Password',
                        sessionPasswordPlaceholder:'Enter password',
                        sessionForgotPassword:'Forgot password?',
                        sessionSignInButton: 'Sign in',
                        dashboardUser: 'Users',
                        dashboardKey: 'Add key',
                        dashboardEditLock:'Edit Locks',
                        tableUsersCol1:'Lock',
                        tableUsersCol2:'Name',
                        tableUsersCol3:'Surname',
                        tableUsersCol4:'Email',
                        tableUsersCol5:'Start',
                        tableUsersCol6:'Finish',
                        tableUsersBack:'Back',
                        tableUsersNext:'Next',
                        keyEmail:'Email',
                        keyNotRegisteredEmail:'This email does not exist within the database, therefore we will create a user with a random password.',
                        keyRegisteredEmail:'This email has been found',
                        keyInitDate:'Commencement date',
                        keyFinishDate:'Completion date',
                        keySelectLock:'Lock',
                        keySelection:'Choose...',
                        keyAdd:'Add',
                        lockNameUpdate:'Select a lock to update',
                        lockNewNameUpdate: 'Name of lock',
                        lockNewDescriptionUpdate: 'Description of locker',
                        lockUpdateButton:'Update',
                        ResetPassEmail: 'Email address',
                        ResetPassOld: 'Old password',
                        ResetPassNew: 'New password',
                        ResetPassNewConfirm: 'Confirm new password',
                        ResetPassName:'Name',
                        ResetPassSurname:'Surname',
                        ResetPassPhone:'Phone',
                        PlaceholderResetPassEmail: 'Type your email address',
                        PlaceholderResetPassOld: 'Type your password to verify and could update your account',
                        PlaceholderResetPassNew: 'Type your new password',
                        PlaceholderResetPassNewConfirm: 'Confirm your new password',
                        dashboardEditUser: 'Owner Account',
                        userUpdateButton: 'Update',
                        userUpdateCorrectLogin: 'The login credentials correspond to the account',
                        userUpdateUncorrectLogin:'The login credentials not correspond to the account',
                        userUpdateCorrectConfirmPass: 'New password and the confirm password are the same',
                        userUpdateUncorrectConfirmPass:'New password and the confirm password are not the same',
                        passwordForgotEmail: 'An email will be sent to the address provided to reset the password',
                        passwordForgotEmail2: 'This email must be the same as the one used to log in',
                        passwordForgotSendButton: 'Send email',
                        passwordForgotNotEmptyEmail:'Type an email',
                        addKeyLanguage: 'All languages',
                        addKeyLanguages: 'Select the language of the user',
                        correctLogin:'Correct Login',
                        uncorrectLogin: 'Uncorrect Login',
                        sendEmailForgotPassword:'Email sent',
                        noSendEmailForgotPassword:'Email not sent',
                        noEmailForgotPassword:'Type an email',
                        userCreated:'A user has been created',
                        userSendEmail:'The email has been sent',
                        errorSelectLocker:'Select a locker',
                        errorUpdateLocker:'Introduce new locker name or a new locker description',
                        lockerUpdate:'Locker Updated',
                        lockerNotUpdate:'Locker not Updated',
                        ownerUpdate:'Owner Updated',
                        ownerNotUpdate:'Owner not Updated',
                        logoutTextTitle:'Do you want to logout?',
                        logoutTextOption:'Yes',
                        logoutTextCancelOption:'Cancel',
                        deletingKeyTitle:'Are you sure?',
                        deletingKeyText:'You are deleting a key',
                        deletingKeyConfirmButton:'Delete',
                        deletingKeyOk:'Key deleted successfully',
                    },    
                    'es': 
                    {
                        sessionEmail: 'Dirección email',
                        sessionEmailPlaceholder:'Introduzca email',  
                        sessionPassword:'Contraseña',
                        sessionPasswordPlaceholder:'Introduzca la contraseña',
                        sessionForgotPassword:'¿Olvidaste la contraseña?',
                        sessionSignInButton:'Iniciar Sesión',
                        dashboardUser: 'Usuarios',
                        dashboardKey: 'Añadir llave',
                        dashboardEditLock:'Editar cerradura',
                        tableUsersCol1:'Cerradura',
                        tableUsersCol2:'Nombre',
                        tableUsersCol3:'Apellidos',
                        tableUsersCol4:'Email',
                        tableUsersCol5:'Inicio',
                        tableUsersCol6:'Fin',
                        tableUsersBack:'Atrás',
                        tableUsersNext:'Siguiente',
                        keyEmail:'Email',
                        keyNotRegisteredEmail:'No existe este correo, dentro de la base de datos, por tanto se procederá a crear un usuario con una contraseña aleatoria.',
                        keyRegisteredEmail:'El correo ha sido encontrado.',
                        keyInitDate:'Fecha de inicio',
                        keyFinishDate:'Fecha de finalización',
                        keySelectLock:'Cerradura',
                        keySelection:'Elige...',
                        keyAdd:'Añadir',
                        lockNameUpdate:'Seleccione una cerradura para actualizar',
                        lockNewNameUpdate: 'Nombre de la cerradura',
                        lockNewDescriptionUpdate: 'Descripción de la cerradura',
                        lockUpdateButton:'Actualizar',
                        ResetPassEmail: 'Dirección de correo',
                        ResetPassOld: 'Contraseña antigua',
                        ResetPassNew: 'Contraseña nueva',
                        ResetPassNewConfirm: 'Confirmación de la nueva contraseña',
                        ResetPassName:'Nombre',
                        ResetPassSurname:'Apellidos',
                        ResetPassPhone:'Teléfono',
                        PlaceholderResetPassEmail: 'Introduce tu dirección de correo electrónico',
                        PlaceholderResetPassOld: 'Introduce tu contraseña para verificar y poder actualizar tu perfil',
                        PlaceholderResetPassNew: 'Introduce tu nueva contraseña',
                        PlaceholderResetPassNewConfirm: 'Confirma tu nueva contraseña',
                        dashboardEditUser: 'Perfil Propietario',
                        userUpdateButton: 'Actualizar',
                        userUpdateCorrectLogin: 'Las credenciales corresponden a la cuenta',
                        userUpdateUncorrectLogin:'Las credenciales no corresponden a la cuenta',
                        userUpdateCorrectConfirmPass: 'La nueva contraseña y la confirmación son iguales',
                        userUpdateUncorrectConfirmPass:'La nueva contraseña y la confirmación no son iguales',
                        passwordForgotEmail: 'Se enviará un email a la dirección proporcionada para reestablecer la contraseña',
                        passwordForgotEmail2: 'Este email tiene que ser el mismo que se usa para iniciar sesión',
                        passwordForgotSendButton: 'Enviar email',
                        passwordForgotNotEmptyEmail:'Introduce un email',
                        addKeyLanguage: 'Todos los idiomas',
                        addKeyLanguages: 'Seleccione el idioma del usuario',
                        correctLogin:'Login Correcto',
                        uncorrectLogin: 'Login Incorrecto',
                        sendEmailForgotPassword:'Email enviado',
                        noSendEmailForgotPassword:'Email no enviado',
                        noEmailForgotPassword:'Introduzca un email',
                        userCreated:'Se ha creado un usuario',
                        userSendEmail:'Se ha enviado el correo',
                        errorSelectLocker:'Seleccione una cerradura',
                        errorUpdateLocker:'Introduce un nombre nuevo o una descripcion nueva de la cerradura',
                        lockerUpdate:'Cerradura Actualizada',
                        lockerNotUpdate:'Cerradura no Actualizada',
                        ownerUpdate:'Propietario Actualizado',
                        ownerNotUpdate:'Propietario no Actualizado',
                        logoutTextTitle:'¿Quieres cerrar sesión?',
                        logoutTextOption:'Si',
                        logoutTextCancelOption:'Cancelar',
                        deletingKeyTitle:'¿Estas segur@?',
                        deletingKeyText:'Estas intentando borrar una llave',
                        deletingKeyConfirmButton:'Borrar',
                        deletingKeyOk:'Llave eliminada satisfactoriamente',
                    },
                    'de':
                    {
                        sessionEmail: 'E-Mail-Adresse',
                        sessionEmailPlaceholder:'E-Mail eingeben',  
                        sessionPassword:'Passwort',
                        sessionPasswordPlaceholder:'Geben Sie das Passwort ein',
                        sessionForgotPassword:'Passwort vergessen?',
                        sessionSignInButton:'Login',
                        dashboardUser: 'Benutzer',
                        dashboardKey: 'Schlüssel hinzufügen',
                        dashboardEditLock:'Sperre bearbeiten',
                        tableUsersCol1:'Schloss',
                        tableUsersCol2:'Name',
                        tableUsersCol3:'Nachname',
                        tableUsersCol4:'E-Mail',
                        tableUsersCol5:'Start',
                        tableUsersCol6:'Ende',
                        tableUsersBack:'Zurück',
                        tableUsersNext:'Weiter',
                        keyEmail:'E-Mail',
                        keyNotRegisteredEmail:'Diese E-Mail existiert nicht in der Datenbank, daher werden wir fortfahren, einen Benutzer mit einem zufälligen Passwort zu erstellen',
                        keyRegisteredEmail:'Die E-Mail wurde gefunden',
                        keyInitDate:'Startdatum',
                        keyFinishDate:'Enddatum',
                        keySelectLock:'Schloss',
                        keySelection:'Wählen Sie...',
                        keyAdd:'Hinzufügen',
                        lockNameUpdate:'Wählen Sie eine Sperre zum Aktualisieren',
                        lockNewNameUpdate: 'Name sperren',
                        lockNewDescriptionUpdate: 'Beschreibung des Schlosses',
                        lockUpdateButton:'Aktualisieren',
                        ResetPassEmail: 'E-Mail-Adresse',
                        ResetPassOld: 'Altes Passwort',
                        ResetPassNew: 'Neues Passwort',
                        ResetPassNewConfirm: 'Bestätigung des neuen Passworts',
                        ResetPassName:'Name',
                        ResetPassSurname:'Nachname',
                        ResetPassPhone:'Telefon',
                        PlaceholderResetPassEmail: 'Geben Sie Ihre E-Mail-Adresse ein',
                        PlaceholderResetPassOld: 'Gib dein Passwort ein, um dein Profil zu überprüfen und zu aktualisieren',
                        PlaceholderResetPassNew: 'Geben Sie Ihr neues Passwort ein',
                        PlaceholderResetPassNewConfirm: 'Bestätigen Sie Ihr neues Passwort',
                        dashboardEditUser: 'Besitzerprofil',
                        userUpdateButton: 'Aktualisieren',
                        userUpdateCorrectLogin: 'Die Zugangsdaten entsprechen dem Konto',
                        userUpdateUncorrectLogin:'Die Zugangsdaten entsprechen nicht dem Konto',
                        userUpdateCorrectConfirmPass: 'Neues Passwort und Bestätigung sind gleich',
                        userUpdateUncorrectConfirmPass:'Neues Passwort und Bestätigung sind nicht identisch',
                        passwordForgotEmail: 'Eine E-Mail wird an die angegebene Adresse gesendet, um das Passwort zurückzusetzen',
                        passwordForgotEmail2: 'Diese E-Mail muss mit derjenigen übereinstimmen, mit der du dich angemeldet hast',
                        passwordForgotSendButton: 'E-Mail senden',
                        passwordForgotNotEmptyEmail:'Geben Sie eine E-Mail ein',
                        addKeyLanguage: 'Alle Sprachen',
                        addKeyLanguages: 'Wählen Sie die Sprache des Benutzers aus',
                        correctLogin:'Korrektes Login',
                        uncorrectLogin: 'Falsches Login',
                        sendEmailForgotPassword:'E-Mail gesendet',
                        noSendEmailForgotPassword:'E-Mail nicht gesendet',
                        noEmailForgotPassword:'Geben Sie eine E-Mail ein',
                        userCreated:'Sie haben einen Benutzer angelegt',
                        userSendEmail:'Die Mail wurde gesendet',
                        errorSelectLocker:'Wählen Sie eine Sperre',
                        errorUpdateLocker:'Geben Sie einen neuen Namen oder eine neue Beschreibung der Sperre ein',
                        lockerUpdate:'Aktualisierte Sperre',
                        lockerNotUpdate:'Sperre nicht aktualisiert',
                        ownerUpdate:'Besitzer aktualisiert',
                        ownerNotUpdate:'Besitzer nicht aktualisiert',
                        logoutTextTitle:'Möchten Sie sich abmelden?',
                        logoutTextOption:'Ja',
                        logoutTextCancelOption:'Abbrechen',
                        deletingKeyTitle:'Bist du sicher?',
                        deletingKeyText:'Du versuchst, einen Schlüssel zu löschen',
                        deletingKeyConfirmButton:'Löschen',
                        deletingKeyOk:'Schlüssel erfolgreich entfernt',
                    }
                };
export default new VueI18n({    
                            locale: 'en', // set locale 
                            fallbackLocale: 'es', // set fallback locale    
                            messages, // set locale messages
                        });



// WEBPACK FOOTER //
// ./src/plugins/i18n.js